import * as React from 'react'
import { ReactElement } from 'react'
import { Field, makeStyles, tokens } from '@fluentui/react-components'
import { useThemeClassName_unstable } from '@fluentui/react-shared-contexts'
import LocalDatePicker from './LocalDatePicker'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles({
    doubleField: {
        display: 'grid',
        gridTemplateColumns: '50% 50%',
    },
    tripleField: {
        display: 'grid',
        gridTemplateColumns: '33% 33% 34%',
    },
    horizontalMargins: {
        marginLeft: tokens.spacingHorizontalXS,
    },
    verticalMargins: {
        marginTop: tokens.spacingHorizontalXS,
    },
})

type Props = {
    orientation?: 'vertical' | 'horizontal'
    startValue: string
    endValue: string
    changeStartDate: (date: string) => void
    changeEndDate: (date: string) => void
    showLabel: boolean
}

export default function DateRange(props: Props): ReactElement {
    const themeClassName = useThemeClassName_unstable()
    const styles = useStyles()
    const { t: translate } = useTranslation()

    return (
        <Field
            label={props.showLabel && translate('base.daterange')}
            orientation={props.orientation}
            className={props.orientation === 'horizontal' && styles.tripleField}
        >
            <>
                <LocalDatePicker
                    {...props}
                    popupSurface={{ className: themeClassName }}
                    isoValue={props.startValue}
                    onSelectDate={props.changeStartDate}
                    maxDate={new Date(props.endValue)}
                />
                <LocalDatePicker
                    {...props}
                    className={props.orientation === 'horizontal' ? styles.horizontalMargins : styles.verticalMargins}
                    popupSurface={{ className: themeClassName }}
                    isoValue={props.endValue}
                    onSelectDate={props.changeEndDate}
                    minDate={new Date(props.startValue)}
                />
            </>
        </Field>
    )
}
